import { dataOnce } from "../../main/data/data-read-only";
export function getListOfSongs() {
    return dataOnce("song-history");
}
